/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Checkbox } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import advFormStyles from '../../../styles/AdvancedFormSearch/AdvanceFormSearchStyles';

const AdvFormCheckboxItem = React.memo(({ formField, pageData, setPageData }) => {
  const {
    id, name, value, label, className,
  } = formField;

  const handleOnChange = () => {
    const updatedPageData = { ...pageData };
    updatedPageData.formFields[id].value = !updatedPageData.formFields[id].value;
    setPageData(updatedPageData);
  };

  return (
    <Checkbox
      value={value}
      id={`${id}-checkbox-${name}`}
      key={`${id}-checkbox-${name}`}
      label={<span>{label}</span>}
      name={name}
      onChange={handleOnChange}
      className={className}
      checked={value}
      css={advFormStyles['.fullWidth']}
    />
  );
});
AdvFormCheckboxItem.displayName = 'AdvFormCheckboxItem';

AdvFormCheckboxItem.propTypes = {
  formFields: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }),
  pageData: PropTypes.shape({
    formHeader: PropTypes.string,
    formFields: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
      })
    ),
  }),
  setPageData: PropTypes.func.isRequired,

};
export default AdvFormCheckboxItem;
